<template>
	<div class="specs-column" :class="{ 'spec-column-category': showCategories }">
		<slot />
		<div class="specs-column__items">
			<spec-games-item
				:prebuild-games="prebuildGames"
				:resolution="resolution"
				:show-category="showCategories"
			/>
			<div
				v-for="(category, name, index) in specSection1"
				:key="index"
				class="specs-column__item"
			>
				<spec-item
					:spec-icon="prebuildIcon"
					:show-category="showCategories"
					:show-more-specs="showMoreSpecs"
					:category="category"
					:part-name="name"
					:parts="variantParts"
				/>
			</div>
		</div>

		<div
			class="specs-column__hidden"
			:class="{ 'specs-column__show': showMoreSpecs }"
		>
			<div class="specs-column__items">
				<div
					v-for="(category, name, index) in specSection2"
					:key="index"
					class="specs-column__item"
				>
					<spec-item
						:spec-icon="prebuildIcon"
						:show-category="showCategories"
						:show-more-specs="showMoreSpecs"
						:category="category"
						:part-name="name"
						:parts="variantParts"
					/>
				</div>
			</div>

			<div class="specs-column__items">
				<div
					v-for="(category, name, index) in specSection3"
					:key="index"
					class="specs-column__item"
				>
					<spec-item
						:spec-icon="prebuildIcon"
						:show-category="showCategories"
						:show-more-specs="showMoreSpecs"
						:category="category"
						:part-name="name"
						:parts="variantParts"
					/>
				</div>
			</div>
		</div>

		<spec-features-item
			:variant-parts="variantParts"
			:show-category="showCategories"
		/>
	</div>
</template>

<script>
import { PREBUILD_ICONS_BY_SLUG } from "../constants";
import SpecItem from "./spec-item/index";
import SpecFeaturesItem from "./spec-features-item";
import SpecGamesItem from "./spec-games-item";

export default {
	name: "SpecsColumn",
	inject: ["gamesPerformance"],
	components: {
		SpecItem,
		SpecFeaturesItem,
		SpecGamesItem
	},
	props: {
		prebuildGames: {
			type: [Object, Array],
			default() {
				return [];
			}
		},
		showCategories: {
			type: Boolean,
			default: false
		},
		showMoreSpecs: {
			type: Boolean,
			required: true
		},
		prebuild: {
			type: Object,
			default() {
				return {};
			}
		},
		variant: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			specSection1: {
				cpus: "CPU",
				gpus: "GPU",
				ram: "RAM",
				storage: "Storage"
			},
			specSection2: {
				cases: "Case",
				motherboards: "Motherboard",
				coolers: "CPU Cooler",
				psus: "Power",
				extras: "Accessories"
			},
			specSection3: {
				softwares: "Software",
				warranty: "Warranty"
			},
			// TO-DO: Hardcoded parts in spec-table must change to be dynamic (Change by CMS)
			hardcodedParts: {
				warranty: {
					name: "2-year warranty on all parts & labor",
					short_name: "2-year warranty on all parts & labor",
					part_information: ""
				}
			}
		};
	},
	computed: {
		variantParts() {
			const details = this.variant.details;
			const hardcodedDetails = this.hardcodedParts;

			return {
				...hardcodedDetails,
				...details
			};
		},
		prebuildIcon() {
			const slug = this.prebuild.slug;
			return Object.prototype.hasOwnProperty.call(PREBUILD_ICONS_BY_SLUG, slug)
				? PREBUILD_ICONS_BY_SLUG[slug]
				: {};
		},
		resolution() {
			return this.gamesPerformance.resolution();
		}
	}
};
</script>

<style lang="scss">
.specs-column {
	.spec-item__category {
		width: 90px;
		color: #444259;
		font-size: 14px;
		font-weight: bold;
		flex-shrink: 0;
		margin-right: 12px;
	}
}
</style>

<style lang="scss" scoped>
.specs-column {
	&__items {
		border-bottom: solid 2px #444259;
	}

	&__item {
		padding: 20px 0;
		border-bottom: solid 1px #dbdde0;
		display: flex;
		align-items: center;

		@media (min-width: 991px) {
			padding: 20px;
			height: 75px;
		}
	}

	&__hidden {
		max-height: 0;
		overflow: hidden;
		transition: all 0.3s;
	}

	&__show {
		max-height: 680px;
	}
}

.spec-column-category {
	.specs-table__heading {
		padding: 25px 15px 25px 100px;
	}

	.specs-column__item {
		padding: 20px 0;

		@media (min-width: 991px) {
			padding: 20px 20px 20px 0;
		}
	}
}
</style>
